export const GROUP_ADMINS =
  process.env.NEXT_PUBLIC_COGNITO_GROUP_ADMINS_NAME || "Admins";
export const GROUP_SUPER_ADMINS =
  process.env.NEXT_PUBLIC_COGNITO_GROUP_SUPER_ADMINS_NAME || "SuperAdmins";
export const GROUP_SIGNERS =
  process.env.NEXT_PUBLIC_COGNITO_GROUP_SIGNERS_NAME || "Signers";

export const API_URL = process.env.NEXT_PUBLIC_SIGNING_API_URL;

export const Second = 1000;
export const Minute = 60 * Second;

// Defaults
export const DefaultDebounceWait = 300;
export const DefaultPaginationLimitOptions = [10, 20, 50, 100];
// Remember that this value has to be present in
// the DefaultPaginationLimitOptions array
export const DefaultPaginationLimit = 10;
